import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <section className='bg-white'>
      <div className='relative my-0 mx-auto h-full max-w-screen-cwidth rounded-lg bg-white py-5 px-4 font-sans break:pr-11 break:pl-4'>
        <div className='flex flex-wrap gap-3 sm:flex-row sm:gap-16'>
          <div className='text-base font-semibold'>
            <Link to='/guid'>Guid</Link>
          </div>
          <div className='text-base font-semibold'>
            <Link to='/feedback'>Feedback</Link>
          </div>
          {/* <div className='text-base font-semibold'>
            <Link to='/terms&condition'>Terms & Condition</Link>
          </div> */}
          <div className='text-base font-semibold'>
            <Link to='/contact'>Contact</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
